App.CommunicationChannelsIndexController = Em.Controller.extend
  needs: [ 'communication-channels' ]

  env:      Em.inject.service('environment')
  realTime: Em.inject.service('realTime')

  channelsBinding: 'model'

  iframeLink: null
  showIframePopover: false

  
  init: ->
    @get('realTime').on('communicationChannelUpdated', @, @updateChannnel)


  updateChannnel: (data) ->
    findedChannel = @get('channels').find (channel) => Number(channel.get('id')) is data.communication_channel_id
    return unless findedChannel
    findedChannel.set('status', data.status)

  actions:
    openChannel: (channel) ->
      @transitionToRoute 'communication-channels.communication-channel.edit', channel.get('id')

    authChannel: (channel) ->
      defer = Em.RSVP.defer()
      channel.set('isAuthLoading', true)
      channel.getAuthLink().then (data) =>
        @set('iframeLink', data.link)
        channel.set('isAuthLoading', false)
        console.log(@get('miniPopups'))
        @get('miniPopups').send('openPopup', 'qr-popup')

      defer.promise
        